import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { VideoPlayerStateType } from '@/components/Player/modules/reducers/videoPlayer';
import VideoPlayerHls from '../VideoPlayerHls';

export const VideoPlayer = ({ useHls }: { useHls: boolean }): ReactElement => {
  const videoPlayer: VideoPlayerStateType = useSelector(
    (state: { videoPlayer: VideoPlayerStateType }) => state.videoPlayer,
  );

  if (videoPlayer.options && videoPlayer.loaded) {
    return videoPlayer.options.map((option: any, index: number) => (
      <VideoPlayerHls
        key={`${option.frameId}-${index}`}
        useHls={useHls}
        videoLink={option.sources[0].src}
        option={option}
      />
    ));
  }

  return <div />;
};

export default VideoPlayer;
